import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fetches DB-managed page configs. Returns null until loaded or if the DB is
// empty/unreachable — callers merge over the local config file as fallback.
export const usePagesData = () => {
  const [apiPages, setApiPages] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API}/pages`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!cancelled && data && Object.keys(data).length > 0) setApiPages(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return apiPages;
};
